<template>
  <div v-if="row" class="rcp-panel">
    <div class="rcp-panel__kpis">
      <div v-for="(col, i) in shiftCols" :key="col" class="ui-stat">
        <span class="ui-stat__label"><report-shift-tag :shift="col"></report-shift-tag></span>
        <span class="ui-stat__value">{{ row.shown[i] ? ctl.fq(row.shown[i]) : "—" }}</span>
      </div>
    </div>

    <div class="rcp-wide">
      <table class="rcp-panel__table">
        <thead>
          <tr>
            <th scope="col">{{ $t("recipes_shell.meal") }}</th>
            <th scope="col">{{ $t("recipes_shell.portions") }}</th>
            <th scope="col">{{ $t("recipes_shell.norm") }}</th>
            <th scope="col">{{ $t("recipes_shell.quantity") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="part in row.parts" :key="part.meal">
            <td>
              {{ toLatin(part.meal) }}
              <span class="rcp-bar"><i :style="{ width: `${share(part)}%` }"></i></span>
            </td>
            <td>{{ ctl.fq(portionsOf(part)) }}</td>
            <td>{{ ctl.fn(part.norm) }}</td>
            <td>
              <b>{{ ctl.fq(roundedPart(part)) }}</b>
              <span class="rcp-unit">&nbsp;{{ row.measure }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-if="ctl.price && row.price != null" class="rcp-panel__price">
      {{ $t("recipes_shell.price_line", { price: priceText, cost: costText }) }}
    </p>

    <div class="rcp-panel__foot">
      <button type="button" class="ui-btn ui-btn--sm" @click="ctl.copyIngredient(row)">
        <v-icon size="16">mdi-content-copy</v-icon>
        {{ $t("copy") }}
      </button>
    </div>
  </div>
  <p v-else class="rcp-muted">{{ $t("recipes_shell.ingredient_gone") }}</p>
</template>

<script>
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";
import { roundQty } from "../recipesLogic";

/** Raspodjela jedne namirnice po jelima: koliko porcija, kolika je norma i koliko ukupno ide na to jelo. */
export default {
  name: "IngredientPanel",
  components: { ReportShiftTag },
  inject: { ctl: "recipesCtl" },
  props: {
    rowKey: { type: String, required: true },
  },
  computed: {
    row() {
      return this.ctl.ingredientByKey(this.rowKey);
    },
    shiftCols() {
      return [...this.ctl.shifts].sort();
    },
    max() {
      return this.row && this.row.parts.length ? this.row.parts[0].exactTotal : 1;
    },
    priceText() {
      return `${this.ctl.fm(this.row.price)} ${this.ctl.currency}`.trim() + `/${this.row.measure}`;
    },
    costText() {
      return `${this.ctl.fm(this.row.cost)} ${this.ctl.currency}`.trim();
    },
  },
  methods: {
    share(part) {
      return Math.max(4, Math.round((100 * part.exactTotal) / this.max));
    },
    portionsOf(part) {
      return part.counts.reduce((total, n) => total + n, 0);
    },
    roundedPart(part) {
      return roundQty(part.exactTotal, this.row.measure);
    },
  },
};
</script>
